import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DialogData, RollenverwaltungPageformComponent} from '../rollenverwaltung-pageForm/rollenverwaltung-pageform.component';
import {select, Store} from '@ngrx/store';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {loadRechteStart} from '../../store/actions/getAllRechte.actions';
import {addRolleStart} from '../../store/actions/rolle-add.actions';
import {editRolleStart} from '../../store/actions/rolle-edit.actions';
import {MatSelect} from '@angular/material/select';


@Component({
  selector: 'app-rollenverwaltung-formdialog',
  templateUrl: './rollenverwaltung-formdialog.component.html',
  styleUrls: ['./rollenverwaltung-formdialog.component.scss']
})


export class RollenverwaltungFormdialogComponent implements OnInit {



  constructor(public dialogRef: MatDialogRef<RollenverwaltungFormdialogComponent>,
              private store: Store<{ mitarbeiterverwaltung: State }>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData)
  {
    dialogRef.disableClose = true;
    this.rollenForm.patchValue({
      bezeichnung: data.bezeichnung,
      rechte: data.rechte,
      id: data.id,
    });
    this.$rechte = store.pipe(select((state) => state.mitarbeiterverwaltung.rechte.items));
  }

  public $rechte;
  public rollenForm = new FormGroup({
    bezeichnung: new FormControl('' , [Validators.required, Validators.maxLength(255)]),
    rechte: new FormControl('', [Validators.required]),
    id: new FormControl(''),
  });
  // tslint:disable-next-line:variable-name
  public last_selection = null;
  @ViewChild('mySel') private skillSel: MatSelect;

  public getErrorMessage(formField: string): string {
    const formControl = this.rollenForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pattern`;
    }
    return 'pages.zeitverwaltung.spesenDialog.err.generic';
  }

  public handleSubmitClick(): void{
    const item = this.rollenForm.value;
    // Rolle hinzufügen, da die ID nicht gesetzt ist
    if (!this.rollenForm.value.id){
      this.store.dispatch(addRolleStart({rolle: item}));
    }
    // Rolle editieren, da eine ID mitgegeben wurde
    else{
      this.store.dispatch(editRolleStart({rolle: item}));
    }
    this.dialogRef.close(true);
  }


  public handleCancelClick(): void{
    this.dialogRef.close(true);

  }


  ngOnInit(): void {
    this.store.dispatch(loadRechteStart());
  }

  okClicked(): void {
    this.last_selection = this.rollenForm.controls.rechte.value;
    this.skillSel.close();
  }
}
